export default __webpack_public_path__ + "static/media/driver_black.b557d21b.svg";